import React from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Link } from 'react-router-dom'

import {
  flatNames,
  getNumberOfOffers,
} from '../../../helpers/getNumberOfOffers'
import { getProject } from '../../../store/project/project'
import style from './ProjectTable.module.scss'

const ProjectTable = () => {
  const { project } = useSelector(getProject)
  const { id } = useParams()

  return (
    <div className={style.ProjectTable}>
      {project && (
        <>
          <h2>Выберите квартиру</h2>
          <div className={style.ProjectTable__items}>
            {project.rooms.map((el, index) => (
              <Link
                to={`/flats/${id}?rooms=${
                  el.TYPE !== 'studio' ? el.TYPE.split('rooms')[1] : el.TYPE
                }`}
                key={index}
                className={style.ProjectTable__item}
              >
                <div className={style['ProjectTable__item-type']}>
                  {el.TYPE === 'studio'
                    ? 'Студии'
                    : `${el.TYPE.split('rooms')[1]}-комнатные`}
                </div>
                <div className={style['ProjectTable__item-size']}>
                  от {el.MIN_AREA} м<sup>2</sup> до {el.MAX_AREA} м<sup>2</sup>
                </div>
                <div className={style['ProjectTable__item-cost']}>
                  {el.MIN_PRICE}–{el.MAX_PRICE} млн ₽
                </div>
                <div className={style['ProjectTable__item-offers']}>
                  {getNumberOfOffers(Number(el.CNT))}
                </div>
              </Link>
            ))}
          </div>
          <Link className={style.ProjectTable__button} to={`/flats/${id}`}>
            {`Всего ${getNumberOfOffers(
              Number(project.cnt),
              flatNames
            )} в проекте`}
          </Link>
        </>
      )}
    </div>
  )
}

export default ProjectTable
